import React from 'react';

const icon = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 14">
        <title>svg departure</title>

        <path  d="M20,9.06l-1.61,1.73a2.05,2.05,0,0,0-.54,1.37A1.78,1.78,0,0,0,19.54,14a1.59,1.59,0,0,0,1.13-.49l0,0,.05-.06L26,7,20.75.55A1.65,1.65,0,0,0,19.54,0a1.78,1.78,0,0,0-1.71,1.84,1.92,1.92,0,0,0,.51,1.31L20,4.92H8.91A2,2,0,0,0,7,7,2,2,0,0,0,8.91,9.06Z"/>
        <path  d="M0,7A2,2,0,1,0,2,5,2,2,0,0,0,0,7"/>
      </svg>
  )
}

export default icon



// WEBPACK FOOTER //
// ./src/shared/images/svg/ida.js